function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "logo",
  transform: "translate(-24.806 -42.086)"
}, React.createElement("g", {
  id: "Group_2",
  "data-name": "Group 2",
  transform: "translate(88.846 58.837)"
}, React.createElement("g", {
  id: "Group_1",
  "data-name": "Group 1"
}, React.createElement("path", {
  id: "Path_1",
  "data-name": "Path 1",
  d: "M250.8,112.862c0-6.631,4.137-11.562,10.683-11.562s10.655,4.931,10.655,11.562-4.109,11.533-10.655,11.533C254.966,124.395,250.8,119.492,250.8,112.862Zm16.776,0c0-4.421-1.984-7.878-6.036-7.878s-6.149,3.457-6.149,7.878c0,4.392,2.069,7.849,6.121,7.849S267.576,117.254,267.576,112.862Z",
  transform: "translate(-250.8 -101.272)",
  fill: "#e86161"
}), React.createElement("path", {
  id: "Path_2",
  "data-name": "Path 2",
  d: "M334.8,102.9h10.173c4.279,0,7.113,2.465,7.113,6.177a5.09,5.09,0,0,1-4.052,5.356v.085c2.04.6,3.089,1.757,3.372,4.449.312,3.117.2,5.526.963,5.866v.227h-4.307c-.567-.255-.623-2.72-.793-5.1-.2-2.409-1.559-3.769-4.336-3.769h-3.627v8.841H334.8Zm4.506,9.776h4.761c2.437,0,3.655-1.275,3.655-3.032,0-1.785-1.133-3.117-3.542-3.117h-4.9v6.149Z",
  transform: "translate(-310.997 -102.418)",
  fill: "#e86161"
}), React.createElement("path", {
  id: "Path_3",
  "data-name": "Path 3",
  d: "M406,102.828h4.506v8.813l8.529-8.841h5.582l-8.7,8.869,9.238,13.29h-5.271l-7.113-10.343-2.267,2.3v8.048H406Z",
  transform: "translate(-362.021 -102.347)",
  fill: "#e86161"
}), React.createElement("path", {
  id: "Path_4",
  "data-name": "Path 4",
  d: "M486.945,120.838h-.057a6.613,6.613,0,0,1-6.234,3.429,10.07,10.07,0,0,1-7.764-3.23,13.138,13.138,0,0,1,.737-17.286,10.151,10.151,0,0,1,7.113-2.55c5.582,0,8.756,3.06,9.493,7.4H485.84c-.482-2.125-2.125-3.684-4.987-3.684-4.194,0-6.262,3.457-6.262,7.878,0,4.534,2.38,7.849,6.206,7.849a5.426,5.426,0,0,0,5.7-5.016v-.113h-5.327v-3.457h9.323v11.76h-3.372Z",
  transform: "translate(-407.885 -101.2)",
  fill: "#e86161"
}))), React.createElement("g", {
  id: "Group_7",
  "data-name": "Group 7",
  transform: "translate(24.806 42.086)"
}, React.createElement("path", {
  id: "Path_5",
  "data-name": "Path 5",
  d: "M159.7,87.9v-.482c-.028-.17-.028-.312-.057-.482a4.838,4.838,0,0,0-1.955-3.259,6.688,6.688,0,0,0-1.615-.822,10.508,10.508,0,0,0-3.315-.453,19.427,19.427,0,0,0-3.174.34,31.081,31.081,0,0,0-5.979,1.842c1.02-.2,2.04-.4,3.06-.538s2.04-.255,3.06-.312a17.674,17.674,0,0,1,3,.057,9.54,9.54,0,0,1,2.749.68,3.358,3.358,0,0,1,1.757,1.587,3.747,3.747,0,0,1,.142,2.324,10.028,10.028,0,0,1-1.02,2.522,25.172,25.172,0,0,1-1.587,2.409c-.368.482-.737.935-1.133,1.389a5.269,5.269,0,0,1,2.154,2.012c.453-.567.878-1.162,1.275-1.757a25.84,25.84,0,0,0,1.644-2.862,12.356,12.356,0,0,0,1.02-3.287,2.436,2.436,0,0,0,.028-.453l.028-.227A.259.259,0,0,1,159.7,87.9Z",
  transform: "translate(-109.937 -70.976)",
  fill: "#e86161"
}), React.createElement("circle", {
  id: "Ellipse_1",
  "data-name": "Ellipse 1",
  cx: 3.769,
  cy: 3.769,
  r: 3.769,
  transform: "translate(37.488 24.629)",
  fill: "#e86161"
}), React.createElement("g", {
  id: "Group_3",
  "data-name": "Group 3",
  transform: "translate(0 24.402)"
}, React.createElement("path", {
  id: "Path_6",
  "data-name": "Path 6",
  d: "M36.479,146.789a1.616,1.616,0,0,1,.028-.368c-.822.17-1.672.312-2.494.425-.482.057-.935.085-1.417.113-.453,0-.935,0-1.389-.028a6.147,6.147,0,0,1-2.409-.6,2.656,2.656,0,0,1-1.36-1.474,4.5,4.5,0,0,1,0-2.38,12.491,12.491,0,0,1,.992-2.635,19.6,19.6,0,0,1,1.53-2.55,40.5,40.5,0,0,1,3.826-4.732c1.389-1.5,2.862-2.947,4.392-4.364a48.629,48.629,0,0,0-5.072,3.627,36.836,36.836,0,0,0-4.534,4.392,29.052,29.052,0,0,0-1.927,2.579A13.588,13.588,0,0,0,25.2,141.83a8.785,8.785,0,0,0-.368,1.757,5.758,5.758,0,0,0,.142,1.955,4.66,4.66,0,0,0,.935,1.87,5.632,5.632,0,0,0,1.53,1.332,7.548,7.548,0,0,0,1.729.737,12.926,12.926,0,0,0,1.757.368,19.3,19.3,0,0,0,3.372.085,26.845,26.845,0,0,0,3.032-.368A4.613,4.613,0,0,1,36.479,146.789Z",
  transform: "translate(-24.806 -128.2)",
  fill: "#e86161"
}), React.createElement("path", {
  id: "Path_7",
  "data-name": "Path 7",
  d: "M113.885,149.1c-.085.085-.2.142-.283.227-1.615,1.218-3.259,2.38-4.959,3.429-1.7,1.077-3.429,2.1-5.214,3.06-1.672.907-3.4,1.729-5.129,2.494a5.245,5.245,0,0,1,1.3,3.315q2.848-1.19,5.526-2.635c1.87-.992,3.684-2.1,5.441-3.23,1.757-1.162,3.485-2.409,5.129-3.74a4.932,4.932,0,0,0,.4-.34A5.071,5.071,0,0,1,113.885,149.1Z",
  transform: "translate(-77.474 -143.178)",
  fill: "#e86161"
})), React.createElement("circle", {
  id: "Ellipse_2",
  "data-name": "Ellipse 2",
  cx: 3.769,
  cy: 3.769,
  r: 3.769,
  transform: "translate(13.118 39.222)",
  fill: "#c0c2cc"
}), React.createElement("path", {
  id: "Path_8",
  "data-name": "Path 8",
  d: "M82.155,50.534a5.253,5.253,0,0,1,2.947.907c.255-.708.51-1.389.793-2.069a15.478,15.478,0,0,1,1.36-2.437c.142-.17.255-.368.4-.538l.2-.255.227-.227c.142-.17.312-.283.453-.425.085-.057.142-.113.227-.17a.994.994,0,0,1,.227-.142l.227-.142a1.952,1.952,0,0,0,.227-.085,1.166,1.166,0,0,1,.227-.085.876.876,0,0,1,.227-.057,2.355,2.355,0,0,1,.992.028,4.465,4.465,0,0,1,2.04,1.275c.34.312.623.68.935,1.02a12.566,12.566,0,0,1,.822,1.19A20.961,20.961,0,0,1,96.1,50.931,46.887,46.887,0,0,1,98.279,56.6c.6,1.955,1.105,3.939,1.559,5.979-.028-1.048-.113-2.069-.2-3.117-.113-1.02-.227-2.069-.4-3.089a38.578,38.578,0,0,0-1.5-6.121,26.568,26.568,0,0,0-1.247-2.975,13.29,13.29,0,0,0-1.842-2.805,8.952,8.952,0,0,0-1.3-1.218,5.908,5.908,0,0,0-1.729-.907,4.627,4.627,0,0,0-2.069-.227,3.194,3.194,0,0,0-.51.085,3.3,3.3,0,0,0-.51.113l-.482.17a3.383,3.383,0,0,0-.453.227,1.691,1.691,0,0,0-.425.255c-.142.085-.283.17-.4.255a7.509,7.509,0,0,0-.737.6l-.34.312-.312.34a6,6,0,0,0-.567.68,17.288,17.288,0,0,0-1.814,2.862A21.962,21.962,0,0,0,81.9,50.534Z",
  transform: "translate(-65.721 -42.086)",
  fill: "#bfc2cd"
}), React.createElement("g", {
  id: "Group_4",
  "data-name": "Group 4",
  transform: "translate(13.251 18.253)"
}, React.createElement("path", {
  id: "Path_9",
  "data-name": "Path 9",
  d: "M72.343,125.486c.057.425.142.822.2,1.247a5.163,5.163,0,0,1,2.635-.708,4.654,4.654,0,0,1,.652.057c-.057-.34-.085-.68-.142-1.02-.113-.992-.227-1.984-.312-3-.085-.992-.142-2.012-.17-3-.085-2.012-.085-4.024-.028-6.036.057-1.984.227-3.967.453-5.922a4.911,4.911,0,0,1-.907.085,5.3,5.3,0,0,1-2.579-.68v.085c-.283,2.1-.453,4.222-.538,6.319-.057,2.125-.057,4.222.057,6.319C71.833,121.292,72.031,123.417,72.343,125.486Z",
  transform: "translate(-71.569 -106.5)",
  fill: "#bfc2cd"
}), React.createElement("path", {
  id: "Path_10",
  "data-name": "Path 10",
  d: "M98.5,201.767c-.227.453-.482.878-.737,1.3a11.749,11.749,0,0,1-.85,1.218,8.739,8.739,0,0,1-2.012,1.955,3.116,3.116,0,0,1-2.267.567c-.057,0-.085-.028-.142-.028l-.142-.028-.142-.028c-.057-.028-.085-.028-.142-.057a1.006,1.006,0,0,1-.255-.113l-.255-.142a4.9,4.9,0,0,1-.992-.765,10.937,10.937,0,0,1-1.644-2.21,20.058,20.058,0,0,1-1.247-2.607c-.142-.34-.255-.68-.4-1.02a4.945,4.945,0,0,1-2.777.85c.2.425.368.878.6,1.3a20.5,20.5,0,0,0,1.615,2.862,12.88,12.88,0,0,0,2.267,2.579,7.1,7.1,0,0,0,1.53.992,4.686,4.686,0,0,0,1.87.482A4.435,4.435,0,0,0,94.3,208.6a5.217,5.217,0,0,0,1.587-.935,8.034,8.034,0,0,0,1.19-1.218,14.483,14.483,0,0,0,.935-1.36,19.286,19.286,0,0,0,1.332-2.919,30.444,30.444,0,0,0,1.445-6.064A32.953,32.953,0,0,1,98.5,201.767Z",
  transform: "translate(-80.836 -170.71)",
  fill: "#bfc2cd"
})), React.createElement("g", {
  id: "Group_6",
  "data-name": "Group 6",
  transform: "translate(0.253 10.754)"
}, React.createElement("path", {
  id: "Path_11",
  "data-name": "Path 11",
  d: "M29.752,83.143a8.7,8.7,0,0,1,2.635-.425,16.458,16.458,0,0,1,2.862.227c.482.085.935.17,1.417.255v-.255a5.136,5.136,0,0,1,.708-2.607c-.6-.085-1.19-.17-1.785-.227a18.825,18.825,0,0,0-3.344,0,10.155,10.155,0,0,0-3.429.85A5.716,5.716,0,0,0,27.23,82.01,4.912,4.912,0,0,0,26.1,83.625a5.691,5.691,0,0,0-.4,1.9,7.335,7.335,0,0,0,.227,1.785,11.918,11.918,0,0,0,1.332,3.06,21.723,21.723,0,0,0,1.87,2.607,31.426,31.426,0,0,0,4.534,4.364c-.68-.793-1.332-1.587-1.955-2.409s-1.218-1.672-1.757-2.522a20.226,20.226,0,0,1-1.445-2.664A11.366,11.366,0,0,1,27.655,87a3.827,3.827,0,0,1,.312-2.437A3.358,3.358,0,0,1,29.752,83.143Z",
  transform: "translate(-25.7 -80.036)",
  fill: "#80869b"
}), React.createElement("g", {
  id: "Group_5",
  "data-name": "Group 5",
  transform: "translate(20.204 3.078)"
}, React.createElement("path", {
  id: "Path_12",
  "data-name": "Path 12",
  d: "M112.925,103.623a5.272,5.272,0,0,1,2.324-2.692c-1.587-1.275-3.259-2.494-4.959-3.627-1.785-1.162-3.6-2.267-5.469-3.287-1.87-.992-3.8-1.927-5.752-2.749-.283-.113-.6-.227-.878-.368A5.2,5.2,0,0,1,97,94.074c.227.113.482.2.708.312,1.842.822,3.655,1.757,5.412,2.749s3.514,2.04,5.186,3.145C109.893,101.328,111.424,102.433,112.925,103.623Z",
  transform: "translate(-97 -90.9)",
  fill: "#80869b"
}), React.createElement("path", {
  id: "Path_13",
  "data-name": "Path 13",
  d: "M142.966,160.2a9.527,9.527,0,0,0-.765-3.542,17.7,17.7,0,0,0-1.559-3,24.411,24.411,0,0,0-1.842-2.55,5.329,5.329,0,0,1-2.409,2.267q.85.978,1.615,2.04a16.677,16.677,0,0,1,1.445,2.437,6.4,6.4,0,0,1,.708,2.437.95.95,0,0,1,0,.283v.283c0,.085-.028.17-.028.255l-.028.142-.028.113a2.006,2.006,0,0,1-.453.878,3.534,3.534,0,0,1-.85.708,4.922,4.922,0,0,1-.538.283,4.044,4.044,0,0,1-.623.227,4.381,4.381,0,0,1-.652.17c-.227.028-.453.085-.68.113a11.936,11.936,0,0,1-1.445.113,26.363,26.363,0,0,1-2.975-.113,39.958,39.958,0,0,1-6.007-1.105c-1.984-.51-3.967-1.133-5.951-1.814.907.51,1.814.992,2.749,1.474.935.453,1.9.878,2.862,1.275a37.3,37.3,0,0,0,6.036,1.9,20.265,20.265,0,0,0,3.2.453,10.973,10.973,0,0,0,1.672,0c.283,0,.567-.057.85-.057.283-.057.567-.085.878-.142a7.44,7.44,0,0,0,1.757-.567,5.688,5.688,0,0,0,1.615-1.162,5.1,5.1,0,0,0,1.105-1.785l.085-.255.057-.255c.028-.17.085-.34.113-.51l.057-.51A1.342,1.342,0,0,0,142.966,160.2Z",
  transform: "translate(-113.411 -134.041)",
  fill: "#80869b"
}))), React.createElement("circle", {
  id: "Ellipse_3",
  "data-name": "Ellipse 3",
  cx: 3.769,
  cy: 3.769,
  r: 3.769,
  transform: "translate(12.665 9.894)",
  fill: "#80869b"
})));

var SvgLogo = function SvgLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    width: 146.642,
    height: 56.438,
    viewBox: "0 0 146.642 56.438",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo.7d352eef.svg";
export { ForwardRef as ReactComponent };